import { BaseService } from 'services/baseService';
import { SkillModel } from 'types/models/SkillModel';

class SkillService extends BaseService<SkillModel> {
  controllerName = 'skills';
}

export const skillService = new SkillService();
